import { Type } from "class-transformer";
import { Win2000TicketSummaryListOutDTO } from "./win-2000-ticket-summary-list.out.dto";

export class Win2000TicketPaginatedOutDTO {
  @Type(() => Win2000TicketSummaryListOutDTO)
  tickets!: Win2000TicketSummaryListOutDTO[];

  total!: number;
}
